import { useReactiveVar } from "@apollo/client";
import { useUpdateUserFlag, useUpdateUserFlagNewFeature } from "apollo/actions";
import { user as userVar } from "apollo/cache";
import { useEffect } from "react";
import { atom, useRecoilState } from "recoil";

export const enum FLAG_WHAT_IS_NEW {
  full = "new_feature_full",
  inspect = "new_feature_inspect",
  result = "new_feature_result",
  history = "new_feature_history",
  profile = "new_feature_profile",
  setting = "new_feature_setting",
  preset = "new_feature_preset",
  whiteness = "new_feature_whiteness",
  whiteness_inspect = "new_feature_whiteness_inspect",
  whiteness_result = "new_feature_whiteness_result",
  whiteness_history = "new_feature_whiteness_history",
}
export type KeyWhatIsNewType =
  | FLAG_WHAT_IS_NEW.full
  | FLAG_WHAT_IS_NEW.inspect
  | FLAG_WHAT_IS_NEW.result
  | FLAG_WHAT_IS_NEW.history
  | FLAG_WHAT_IS_NEW.profile
  | FLAG_WHAT_IS_NEW.setting
  | FLAG_WHAT_IS_NEW.preset
  | FLAG_WHAT_IS_NEW.whiteness
  | FLAG_WHAT_IS_NEW.whiteness_inspect
  | FLAG_WHAT_IS_NEW.whiteness_result
  | FLAG_WHAT_IS_NEW.whiteness_history;

export type FlagsWhatIsNewType = {
  [x in KeyWhatIsNewType]?: {
    flag: boolean;
    isFirst: boolean;
    isNotShow: boolean;
  };
};

export type FlagsNormal = {
  isFeedbackShowUp?: boolean;
  isShowInfoVersion?: boolean;
};

export type IFlagsProps = FlagsWhatIsNewType & FlagsNormal;

const flagsStateAtom = atom({
  key: "flagsState",
  default: {} as IFlagsProps,
});

function useFlag() {
  const [getUpdateUserFlag] = useUpdateUserFlag();
  const [getUpdateUserFlagNewFeature] = useUpdateUserFlagNewFeature();

  const [flagsState, setFlagsState] = useRecoilState(flagsStateAtom);
  const updateFlags = async (flags: FlagsNormal) => {
    setFlagsState({
      ...flagsState,
      ...flags,
    });

    await getUpdateUserFlag({
      variables: {
        updateFlag: flags,
      },
    });
  };
  const readWhatIsNew = async (key: KeyWhatIsNewType, isNotShow?: boolean) => {
    //api
    const { data } = await getUpdateUserFlagNewFeature({
      variables: {
        key: key,
        isNotShow: isNotShow,
      },
    });

    const result: FlagsWhatIsNewType = {
      [key]: {
        ...data.updateUserFlagNewFeature.flag,
      },
    };

    setFlagsState({
      ...flagsState,
      ...result,
    });
  };

  return {
    flags: flagsState,
    setFlagsState,
    updateFlags,
    readWhatIsNew,
  };
}

export default useFlag;
